import React from 'react';
import './style.css';


function App() {
  return (
    <div className="App"> 
      <div id="name">G Naveen Shrinivas &#128512;</div>
      <p id="primcontact"> 📍 Chennai, India | 📧 naveenshrinivas.ceg.ie@gmail.com | 📱 +918939583110 </p>   
      <div class="flex-container1">
        <div>ABOUT</div>
        <div id="aboutcontent">Studying in College of Engineering, Guindy &#127891; | Recently hooked on to Web Development &#128187; &#128175; | Actively looking for Summer Internship opportunities.</div>
      </div>
      <div class="flex-container2">
        <div>SKILLS</div>
        <div id="skillscontent">🏭 Data Analysis, Web Development, Android Developement (Basics) and Lean Six Sigma (Basics).</div>
      </div>
      <div id="skillscontent1">🧰 MySQL, C++, C, Python, Arduino, HTML, CSS, JavaScript, Bootstrap, Microsoft Office, ReactJS, jQuery (Basics), Django (Basics) and Google Analytics (Basics).</div>  
      <div id="experiencetitle">EXPERIENCE
        <div id="campusambas">Campus Ambassador</div>
        <div id="orgtitle">Internshala | Chennai, India | 📅 May 2020 - Aug 2020</div>
        <div id="orgdetails">&#8594; Appointed to be the Campus Ambassador of Anna University on behalf of Internshala.</div>
      </div>
      <div id="PROJECTS">PROJECTS
        <div id="crypt">Cryptography</div>
        <div id="cryptdetails">&#8594; As part of the 12th-grade curriculum, me and two other students developed a code for evaluating different encryption cyphers using C++ programming language.</div>
        <div id="robo"><a href="https://www.facebook.com/photo.php?fbid=520081388036221&set=pb.100001030947019.-2207520000..&type=3">Quad-Bot</a></div>
        <div id="robodetails">&#8594; Built a 4 legged robot (Quadbot) and programmed it by using Arduino studio.</div>
      </div>
      <div id="awards">AWARDS
        <div id="prof">Academic Proficiency Award</div>
        <div id="profdetails">&#8594; Proficiency award in academics for securing 10/10 CGPA in AISSCE examination.</div>
      </div>
      <div id="education">EDUCATION
        <div id="college">College of Engineering, Guindy</div>
        <div id="degreedetails">B.E Industrial Engineering | 8.51/10 (Till 3rd semester)</div>
        <div id="date1">2018-2022</div>
        <div id="addinfo">&#8594; Member of Society of Industrial Engineers</div>
        <div id="school">SBOA School and Junior College</div>
        <div id="degreedetails1">+2, High School/Secondary Diplomas and Certificates | 12th Grade - 93% | 10th Grade - 10/10</div>
        <div id="date2">2004-2018</div>
        <div id="addinfo2">&#8594; Member of Quiz Club, Lions Club and NSS</div>
      </div>
      <div id="contact">CONTACT
      <div id="contdetails"><a href="https://www.linkedin.com/in/naveen-shrinivas-g-2082bb16b/"><img src="linkedin.png"></img></a> &nbsp; 
        <a href="https://github.com/naveenshrinivas"><img src="github.png"></img></a>
      </div>
      </div>     
    </div>
  );
}

export default App;
